<div class="loader-wrapper" [class.loderhide]="!show">
  <div class="dots-loader">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
